import './App.css';
import MainDash from './components/MainDash';
import RightSide from './components/RightSide';
import SideBar from './components/SideBar';

function App() {
  return (
    <div className="App">
        <div className='Appglass'>
          <SideBar/>
          <MainDash/>
          <RightSide/>
        </div>
    </div>
  );
}

export default App;
